import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/icons/new-alert.svg';
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1);
const _hoisted_2 = { class: "modal-confirm-edit-actions__title" };
const _hoisted_3 = { class: "modal-confirm-edit-actions__text" };
const _hoisted_4 = { class: "dialog modal-confirm-edit-actions__buttons" };
import { reactive, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalConfirmEditActions',
    props: {
        isVisible: { type: Boolean },
        id: {}
    },
    emits: ['hide', 'save'],
    setup(__props, { emit }) {
        const props = __props;
        const state = reactive({
            isVisible: false,
        });
        const hide = () => emit('hide', true);
        const save = () => emit('save', true);
        watch(() => props.isVisible, () => {
            state.isVisible = props.isVisible;
        });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: state.isVisible,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.isVisible) = $event)),
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                width: "450",
                center: "",
                class: "modal-confirm-edit-actions"
            }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t(`campaigns-management.modals.${props.id}.title`)), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`campaigns-management.modals.${props.id}.text`)), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            class: "btn btn-outline-ctx-primary modal-confirm-edit-actions__buttons--hide",
                            onClick: hide
                        }, _toDisplayString(_ctx.$t(`campaigns-management.modals.${props.id}.btn-back`)), 1),
                        _createElementVNode("button", {
                            class: "btn modal-confirm-edit-actions__buttons--save",
                            onClick: save
                        }, _toDisplayString(_ctx.$t(`campaigns-management.modals.${props.id}.btn-save`)), 1)
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
